import { render } from "./FbFieldConfig.vue?vue&type=template&id=28d0183e"
import script from "./FbFieldConfig.vue?vue&type=script&lang=js"
export * from "./FbFieldConfig.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__